<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Cards Operations
      </v-card-title>
      <v-snackbar
          v-if="snackbar"
          v-model="snackbar"
          :timeout="timeout"
          color="#F44336"
          bottom="bottom"
      >
        {{ text }}
        <v-btn color="white" text>
          Fermer
        </v-btn>
      </v-snackbar>
      <v-tabs
          v-model="tab"
          background-color="#373737"
          centered
          dark
          dense
          icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          READ,FORMAT
          <v-icon>mdi-credit-card</v-icon>
        </v-tab>
        <v-tab href="#tab-2">
          WRITE,LOCK,UNLOCK,RESET
          <v-icon>mdi-backup-restore</v-icon>
        </v-tab>
        <v-tab href="#tab-3">
          DEBIT,CREDIT
          <v-icon>mdi-credit-card-multiple</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-col sm="12" class="text-center">
          <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              top
              color="orange accent-4"
          ></v-progress-linear>
        </v-col>
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="6" md="6">
                    <v-text-field :id="dynamicID()"
                                  v-model="formRead.fingerprint"
                                  placeholder="FingerPrint"
                    ></v-text-field>
                    <v-btn color="brown darken-4" dark @click="Cread">
                      <v-icon>mdi-eye</v-icon>
                      Read
                    </v-btn
                    >
                    <v-btn
                        color="brown darken-4"
                        class="ml-2"
                        dark
                        @click="Cformat"
                    >
                      <v-icon>mdi-server-remove</v-icon>
                      Format
                    </v-btn
                    >
                  </v-col>
                  <v-col cols="6" md="6">
                    <vue-json-pretty :data="result"></vue-json-pretty>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card flat>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="6" md="6">
                    <v-text-field :id="dynamicID()"
                                  v-model="formWrite.fingerprint"
                                  placeholder="FingerPrint"
                    ></v-text-field>

                    <v-text-field :id="dynamicID()"
                                  v-model="formWrite.userId"
                                  placeholder="User ID"
                    ></v-text-field>

                    <v-btn
                        color="orange darken-4"
                        class="mr-2 mt-2"
                        dark
                        @click="Cwrite"
                    >
                      <v-icon>mdi-pencil</v-icon>
                      Write
                    </v-btn
                    >

                    <v-btn
                        color="orange darken-4"
                        class="mt-2 mr-2"
                        dark
                        @click="Clock"
                    >
                      <v-icon>mdi-lock</v-icon>
                      Lock
                    </v-btn
                    >

                    <v-btn
                        color="orange darken-4"
                        class="mt-2 mr-2"
                        dark
                        @click="Cunlock"
                    >
                      <v-icon>mdi-lock-open</v-icon>
                      Unlock
                    </v-btn
                    >

                    <v-btn
                        color="orange darken-4"
                        class="mt-2"
                        dark
                        @click="Creset"
                    >
                      <v-icon>mdi-format-clear</v-icon>
                      Reset
                    </v-btn
                    >
                  </v-col>
                  <v-col cols="6" md="6">
                    <vue-json-pretty :data="result2"></vue-json-pretty>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <v-card flat>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="6" md="6">
                    <v-text-field :id="dynamicID()"
                                  v-model="form3.fingerprint"
                                  placeholder="FingerPrint"
                    ></v-text-field>

                    <v-text-field :id="dynamicID()"
                                  v-model="form3.userId"
                                  placeholder="User ID"
                    ></v-text-field>

                    <v-text-field :id="dynamicID()"
                                  v-model="form3.amount"
                                  placeholder="Montant"
                    ></v-text-field>

                    <v-btn
                        color="orange darken-4"
                        class="mr-2"
                        dark
                        @click="credit"
                    >
                      <v-icon>mdi-plus</v-icon>
                      Crédit
                    </v-btn
                    >

                    <v-btn color="orange darken-4" dark @click="debit">
                      <v-icon>mdi-minus</v-icon>
                      Débit
                    </v-btn
                    >
                  </v-col>
                  <v-col cols="6" md="6">
                    <vue-json-pretty :data="result3"></vue-json-pretty>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";
import VueJsonPretty from "vue-json-pretty";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      snackbar: false,
      text: "",
      timeout: 2000,
      tab: null,
      loading: false,
      formRead: {
        fingerprint: ""
      },
      formWrite: {
        fingerprint: "",
        userId: ""
      },
      form3: {
        fingerprint: "",
        userId: "",
        amount: ""
      },
      result: {
        Response: ""
      },
      result2: {
        Response: ""
      },
      result3: {
        Response: ""
      }
    };
  },
  components: {
    VueJsonPretty
  },
  methods: {
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    rndStr(len) {
      let text = "";
      let chars = "abcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return text;
    },
    Cread() {
      if (this.formRead.fingerprint === "") {
        this.snackbar = true;
        this.text = "* Le champ fingerprint est obligatoire";
        return;
      }
      this.loading = true;
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/card/read/` +
              this.formRead.fingerprint +
              "==/" +
              this.rndStr(7)
          )
          .then(res => {
            this.loading = false;
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    Cwrite() {
      if (this.formWrite.fingerprint === "" || this.formWrite.userId === "") {
        this.snackbar = true;
        this.text = "* Les champs fingerprint et userId sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/write/` +
              this.formWrite.fingerprint +
              "==/" +
              this.rndStr(7),
              {
                userId: this.formWrite.userId
              }
          )
          .then(res => {
            this.loading = false;
            this.result2 = res.data;
            // this.formWrite.fingerprint = this.formWrite.userId = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    Cformat() {
      if (this.formRead.fingerprint === "") {
        this.snackbar = true;
        this.text = "* Le champ fingerprint est obligatoire";
        return;
      }
      this.loading = true;
      let url = `${this.$store.getters.user.baseUrl}`
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/format/` +
              this.formRead.fingerprint +
              "==/" +
              this.rndStr(7)
          )
          .then(res => {
            this.loading = false;
            this.result = res.data;
            // this.formRead.fingerprint = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    Clock() {
      if (this.formWrite.fingerprint === "" || this.formWrite.userId === "") {
        this.snackbar = true;
        this.text = "* Les champs fingerprint et userId sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/lock/` +
              this.formWrite.fingerprint +
              "==/" +
              this.formWrite.userId +
              "/" +
              this.rndStr(7)
          )
          .then(res => {
            this.loading = false;
            this.result2 = res.data;
            //this.formWrite.fingerprint = this.formWrite.userId = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    Cunlock() {
      if (this.formWrite.fingerprint === "" || this.formWrite.userId === "") {
        this.snackbar = true;
        this.text = "* Les champs fingerprint et userId sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/unlock/` +
              this.formWrite.fingerprint +
              "==/" +
              this.formWrite.userId +
              "/" +
              this.rndStr(7)
          )
          .then(res => {
            this.loading = false;
            this.result2 = res.data;
            //this.formWrite.fingerprint = this.formWrite.userId = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    Creset() {
      if (this.formWrite.fingerprint === "" || this.formWrite.userId === "") {
        this.snackbar = true;
        this.text = "* Les champs fingerprint et userId sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/reset/` +
              this.formWrite.fingerprint +
              "==/" +
              this.formWrite.userId +
              "/" +
              this.rndStr(7)
          )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result2 = res.data;
            //this.formWrite.fingerprint = this.formWrite.userId = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    credit() {
      if (
          this.form3.fingerprint === "" ||
          this.form3.userId === "" ||
          this.form3.amount === ""
      ) {
        this.snackbar = true;
        this.text =
            "* Les champs fingerprint, userId & montant sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/credit/` +
              this.form3.fingerprint +
              "==/" +
              this.form3.userId +
              "/" +
              this.rndStr(7),
              {
                credit: this.form3.amount
              }
          )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result3 = res.data;
            //this.form3.fingerprint = this.form3.userId = this.form3.amount = "";
          })
          .catch(() => {
            this.loading = false;
          });
    },
    debit() {
      if (
          this.form3.fingerprint === "" ||
          this.form3.userId === "" ||
          this.form3.amount === ""
      ) {
        this.snackbar = true;
        this.text =
            "* Les champs fingerprint, userId & montant sont obligatoires";
        return;
      }
      this.loading = true;
      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/card/debit/` +
              this.form3.fingerprint +
              "==/" +
              this.form3.userId +
              "/" +
              this.rndStr(7),
              {
                debit: this.form3.amount
              }
          )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result3 = res.data;
            //this.form3.fingerprint = this.form3.userId = this.form3.amount = "";
          })
          .catch(() => {
            this.loading = false;
          });
    }
  }
};
</script>
